import { Navigate, Route, Routes } from 'react-router-dom'
import { AppShell } from './components/AppShell'
import { HomePage } from './pages/HomePage'
import { ProductsPage } from './pages/ProductsPage'
import { ProductPage } from './pages/ProductPage'
import { PhotoSearchPage } from './pages/PhotoSearchPage'
import { ComparePage } from './pages/ComparePage'
import { NotFoundPage } from './pages/NotFoundPage'
import { ScrollToTop } from './components/ScrollToTop'
import { ReferenceGuidesPage } from './pages/ReferenceGuidesPage'

export default function App() {
  return <AppShell><ScrollToTop/><Routes>
    <Route path="/" element={<HomePage />} />
    <Route path="/products" element={<ProductsPage />} />
    <Route path="/product/:slug" element={<ProductPage />} />
    <Route path="/photo-search" element={<PhotoSearchPage />} />
    <Route path="/compare" element={<ComparePage />} />
    <Route path="/reference-guides" element={<ReferenceGuidesPage />} />
    <Route path="/dev/recognition-test" element={import.meta.env.DEV ? <PhotoSearchPage developerMode /> : <Navigate to="/" replace />} />
    <Route path="*" element={<NotFoundPage />} />
  </Routes></AppShell>
}
